// Preparing internal reusable constants values
const _cabins = ["economy", "premium economy", "premium business", "delta comfort"];
const _flightFares = [
  "Promo",
  "Basic",
  "Light",
  "Plus",
  "Top",
  "Miles",
  "Standard",
  "Full",
  "Classic",
  "Premium Economy",
  "Premium Economy Standard",
  "Premium Economy Full",
  "Premium Business",
  "Premium Business Standard",
  "Premium Business Full",
  "Other",
  "Delta Comfort",
];
const _seatsNames = [
  "Premium Business",
  "Premium Economy",
  "Extra Space",
  "Front Seats",
  "Emergency Seats",
  "Standard",
];
const _bagsNames = [
  "Personal item",
  "Bag carry on",
  "Bag 10 Kg",
  "Bag 12 Kg",
  "Bag 15 Kg",
  "Bag 23 Kg",
  "Sporting Equipment",
];

const _overweight = [
  "Excess weight up to 23kg",
  "Excess weight up to 32kg",
  "Excess weight up to 45kg",
];

const _flightNumber = new RegExp(/^[A-Z0-9]{2}[0-9]{1,5}$/);

// Preparing export constants
export const keys = {
  CHANNELS: {
    WEB: "web",
    MOBILE: "mobile",
    APP: "app",
  },
  GA_VERSION: {
    UA: "ua",
    GA4: "ga4",
  },
  JOURNEYS: {
    O2C: "O2C",
    D2D: "D2D",
  },
  API_ACTIONS: {
    previousAction: "xp_gaPreviousAction",
  },
  LANGUAGE_REGEX: new RegExp(/^(es|en|pt|de|it|fr)$/),
  // eslint-disable-next-line max-len
  POS_REGEX: new RegExp(
    /^(ar|cl|co|ec|py|pe|uy|un|mx|es|ca|us|uk|ue|au|nz|un|br|de|it|fr|gb|bo)$/
  ),
  // eslint-disable-next-line max-len
  COUNTRIES_REGEX: new RegExp(
    /(Argentina|Chile|Colombia|Ecuador|Paraguay|Perú|Uruguay|México|España|Canada|USA|UK|UE|Australia|Nueva\sZelanda|Others|Brasil|Deutschland|Italia|Francia)/
  ),
  // eslint-disable-next-line max-len
  UUID_REGEX: new RegExp(
    /(^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$)|(^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$)/,
    "i"
  ),
  FAMILY: [
    "Airport",
    "Ancillaries",
    "Application",
    "Biometric",
    "ContactCenter",
    "Corporate",
    "DigitalMarketing",
    "DigitalSales",
    "Information",
    "OrderManagement",
    "Payments",
    "PreFlight",
    "NDC",
    "Internal",
    "LATAMTravel",
    "Antifraud",
    "OrderServicing",
    "User",
    "OrderCare",
    "LatamPass",
    "LATAMPass"
  ],
  SUBFAMILY: [
    "2FA",
    "AccountRecovery",
    "Agent",
    "Bags",
    "BoardingPass",
    "Booking",
    "Checkin",
    "Claims",
    "CMS",
    "Deals",
    "Destinations",
    "Documentation",
    "EmailPreferences",
    "Enrollment",
    "Error",
    "FAQ",
    "Flights",
    "Fulfillment",
    "HelpDesk",
    "Homepage",
    "LATAMPass",
    "Login",
    "Market",
    "MyAccount",
    "MyBookings",
    "Notifications",
    "OrderCentric",
    "PasswordRecovery",
    "P2P",
    "Payment",
    "Polls",
    "Preferences",
    "Seats",
    "Signup",
    "StaffTravel",
    "Tag&Drop",
    "Upgrade",
    "Wallet",
    "Miles",
    "FlightStatus",
    "ContactTracing",
    "SDFC",
    "LATAMTravel",
    "OrdersManagement",
    "PaymentsConsole",
    "Agency",
    "Passenger",
    "Packages",
    "Hotels",
    "Trips",
    "Tours",
    "Activities",
    "Transfers",
    "Insurance",
    "Cars",
    "Cruises",
    "Validation",
    "Biometry",
    "Change",
    "Migration",
    "CreditCard",
    "Refund",
    "InvoluntaryChange",
    "SelfService",
    "Home",
    "Offers",
    "MyLatamPass",
    "Partners",
    "Miles",
    "Multiplica",
    "Institutional",
    "APP",
    "Program",
    "Shopping",
    "Club",
    "Subhome",
    "Checkout",
    "Contingency"
  ],
  PAGE_ACTION: [
    "Add",
    "Change",
    "Disable",
    "Edit",
    "Enable",
    "Error",
    "Log",
    "Migration",
    "Purchase",
    "Refund",
    "Remove",
    "Response",
    "Search",
    "Submit",
    "Delete",
    "Transaction",
    "View",
    "Withdraw",
    "InvoluntaryChange",
    "Redirect",
    "Void",
    "Split",
  ],
  TIMERS: ["xp_search-box-timing"],
  PAGENAME_REGEX: new RegExp(/^[a-zA-Z0-9_-]+$/, "i"),
  ISO_31661_ALPHA2: [
    "AD",
    "AE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AN",
    "AO",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GS",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HM",
    "HN",
    "HR",
    "HT",
    "HU",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TC",
    "TD",
    "TF",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UM",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "YE",
    "YT",
    "YU",
    "ZA",
    "ZM",
    "ZW",
  ],
  CURRENCY_CODES: [
    "ARS",
    "AUD",
    "BRL",
    "CAD",
    "CLP",
    "COP",
    "EUR",
    "GBP",
    "NZD",
    "PYG",
    "USD",
    "PEN",
    "UYU",
  ],
  IATA_CODE_REGEX: new RegExp(/^[A-Z]{3}$/),
  // TODO: Validate dates in a better way.
  DATE_REGEX: new RegExp(/^\d{4}-(0[1-9]|1[0-2])-([0-2][0-9]|3[0-1])$/),
  // eslint-disable-next-line max-len
  DATE_TIME_REGEX: new RegExp(
    /^\d{4}-(0[1-9]|1[0-2])-([0-2][0-9]|3[0-1])\s(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/
  ),
  TIME_REGEX: new RegExp(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/),
  // eslint-disable-next-line max-len
  OPERATING_AIRLINES_REGEX: new RegExp(
    /^([LA|LP|4C|4M|XL|JJ|AA|IB|LH|QF|BA|2Z|UA|AM|SA|B6|AF|AC|AZ|QR|EK|4O|LX|KL|JL|KE|VT|VY|CX|IG|CA|AS|LY|9B|SK|NZ|EY|TK|JQ|AY|SQ|ET|OZ|NH|WS|OS|CZ|MH|KA|TN|MU|EW|SN|OK|CI|MN|LO|LG|AI|MS|TG|S7|OU|RJ|AT|DT|9W|HA|UL|GA|SU]{2})/
  ),
  TRAVEL_TYPES: ["round trip", "one way", "multi city"],
  CABINS: _cabins,
  FLIGHT_PATH_REGEX: new RegExp(/^([A-Z]{3}-[A-Z]{3})(-[A-Z]{3})*$/),
  // eslint-disable-next-line max-len
  SEGMENT_FLIGH_NUMBER_REGEX: new RegExp(
    /^[A-Z0-9]{2}[0-9]+(\s\/\s[A-Z0-9]{2}[0-9]+)*$/
  ),
  // eslint-disable-next-line max-len
  SEGMENT_OPERATOR_REGEX: new RegExp(
    /^([LA|LP|4C|4M|XL|JJ|AA|IB|LH|QF|BA|2Z|UA|AM|SA|B6|AF|AC|AZ|QR|EK|4O|LX|KL|JL|KE|VT|VY|CX|IG|CA|AS|LY|9B|SK|NZ|EY|TK|JQ|AY|SQ|ET|OZ|NH|WS|OS|CZ|MH|KA|TN|MU|EW|SN|OK|CI|MN|LO|LG|AI|MS|TG|S7|OU|RJ|AT|DT|9W|HA|UL|GA|SU]{2})+(| \/ ([LA|LP|4C|4M|XL|JJ|AA|IB|LH|QF|BA|2Z|UA|AM|SA|B6|AF|AC|AZ|QR|EK|4O|LX|KL|JL|KE|VT|VY|CX|IG|CA|AS|LY|9B|SK|NZ|EY|TK|JQ|AY|SQ|ET|OZ|NH|WS|OS|CZ|MH|KA|TN|MU|EW|SN|OK|CI|MN|LO|LG|AI|MS|TG|S7|OU|RJ|AT|DT|9W|HA|UL|GA|SU]{2})+)*$/
  ),
  BUSINESS_UNITS: ["international", "domestic", "regional"],
  LIMIT_PASSENGERS: {
    ADULTS: 9,
    CHILDREN: 9,
    INFANTS: 9,
  },
  CUSTOMER_FFP_CATEGORIES: [
    "LATAM",
    "GOLD",
    "GOLD PLUS",
    "PLATINUM",
    "BLACK",
    "BLACK SIGNATURE",
  ],
  PAYMENT_METHODS_REGEX: new RegExp(/((,)?(^)?(credit card|ewallet))*/),
  ANTICIPATION_PURCHASE_DAYS: 330,
  GENDERS: ["M", "F", "I"],
  // eslint-disable-next-line max-len
  PRODUCT_ID_NAME_REGEX: new RegExp(
    /^((FLIGHT|SEATS|BAGS|HOTEL|CARS|SERVICE|PRIORITY|INSURANCE|PENALTY|CFE|OVERWEIGHT|FLEX|TRIP|TOUR|ACTIVITY|TRANSFER|CRUISE|CAR|PETS|UPGRADE)(-[A-Z]{3})+|(MILES-[0-9]+|MILES)|MULTIPLICA-.+|CLUB-(Lite|Basic|Prime)|ALLIANCE-[A-Za-z]+|EXPERIENCE-[A-Za-z]+)$/i
  ),
  MILES_MONEY_REGEX: new RegExp(/^[0-9]{1,3}-[0-9]{1,3}$/),
  PRODUCT_BRAND: [
    ..._flightFares, // Flights
    ..._seatsNames, // Seats
    ..._bagsNames, // Bags
    ..._overweight, // Overweight
    "Service fee LATAM", // Service Fees

  ],
  PRODUCT_CATEGORY_LEVEL_ONE: [
    "Overweight",
    "Packages",
    "Hotels",
    "Cars",
    "Insurance",
    "Transfers",
    "Cruises",
    "Trips",
    "Tours",
    "Activities",
    "Flights",
    "Miles",
    "Branding",
    "Online assistant",
    "Non air redemption",
    "Cobrand",
    "Alliances",
    "FFP club",
    "Redemption",
    "Parnerships",
    "Carbon offset",
    "Seats",
    "Bags",
    "Upgrade",
    "Pets",
    "Flex",
    "Priority boarding",
    "Service fee",
    "Penalty",
    "CFE",
    "Vacation rentals",
    "Shopping",
    "Upgrade Bid",
    "Upgrade Instant",
    "eSim",
    "Cards",
    "Club",
    "Transfer miles",
    "Multiplica",
    "Experiences",
  ],
  PRODUCT_CATEGORY_LEVEL_TWO: _cabins,
  PRODUCT_CATEGORY_LEVEL_THREE_REGEX: new RegExp(/^(Flight)\s[0-9]{1,2}$/),
  PRODUCT_CATEGORY_LEVEL_FOUR_DEFAULT: _flightFares,
  PRODUCT_CATEGORY_LEVEL_FOUR_REGEX: new RegExp(
    /^(Purchase|Change|Protection)$/
  ),
  PRODUCT_CATEGORY_LEVEL_FIVE_REGEX: _flightNumber,
  FLIGHT_NUMBER_REGEX: _flightNumber,
  PRODUCT_VARIANT_REGEX: new RegExp(/^([0-9]{1,2}[A-L]{1}|[0-9]+|\w{3})$/),
  PNR_REGEX: new RegExp(/^[A-Z0-9]{6}$/),
  PRODUCT_MIN_NUMBER: 0,
  MAX_SCORE: 5,
  // eslint-disable-next-line max-len
  PROMO_ID_NAME_REGEX: new RegExp(
    /^((LASTSEARCH|DESTINATION|LOYALTY|MENU)(-[A-Z]{3})+|(FLAG|NEXTTRIP|PROMO|BANNER|HERO|SLIDER|FILTER|SERVICING|TAB)-(.*))$/
  ),
  // eslint-disable-next-line max-len
  PROMO_POSITION_REGEX: new RegExp(/^\d+$/),
  PURCHASE_MIN_MONEY: 0,
  // eslint-disable-next-line max-len
  CUSTOMER_SCOPE: [
    "customer",
    "agent",
    "corporate",
    "ROLE_AGENCY_AGENT",
    "ROLE_AGENCY_ADMIN",
  ],
  PROFILE_TYPE: ["standard", "light"],
  PASSENGER_TYPE: ["Adult", "Child", "Infant"],
  SESSION_CONTROL: ["start", "end"],
  FLIGHT_TYPE: ["outbound", "inbound", "multi city", "both"],
  SEARCH_TYPE: [
    "order/pnr",
    "order",
    "pnr",
    "ffn",
    "document",
    "email",
    "lastname",
    "search box",
    "article",
    "category",
    "all results",
    "flight number",
    "route",
    "results",
    "no results",
  ],
  MOBILE_ACCESS_COOKIE: "mobile_access",
  MULTIPLE_STRING_REGEX: new RegExp(/^[a-zA-Z0-9]+(\s\/\s[a-zA-Z0-9]+)*$/),
  DIGITAL_SERVICES: ["Chatweb", "Whatsapp", "Video chat queue", "Video chat schedule"],
  CLICK_TYPES: ["External", "Internal"],
  FEEDBACK_VALUES: new RegExp(/^(yes|no|[-+]?(\d*\.)?\d+)$/i),
};
export const CHANNELS = keys.CHANNELS;
export const GA_VERSION = keys.GA_VERSION;
export const JOURNEYS = keys.JOURNEYS;
export const API_ACTIONS = keys.API_ACTIONS;
export const LANGUAGE_REGEX = keys.LANGUAGE_REGEX;
export const POS_REGEX = keys.POS_REGEX;
export const COUNTRIES_REGEX = keys.COUNTRIES_REGEX;
export const UUID_REGEX = keys.UUID_REGEX;
export const FAMILY = keys.FAMILY;
export const SUBFAMILY = keys.SUBFAMILY;
export const PAGE_ACTION = keys.PAGE_ACTION;
export const TIMERS = keys.TIMERS;
export const PAGENAME_REGEX = keys.PAGENAME_REGEX;
export const ISO_31661_ALPHA2 = keys.ISO_31661_ALPHA2;
export const CURRENCY_CODES = keys.CURRENCY_CODES;
export const IATA_CODE_REGEX = keys.IATA_CODE_REGEX;
export const DATE_REGEX = keys.DATE_REGEX;
export const DATE_TIME_REGEX = keys.DATE_TIME_REGEX;
export const TIME_REGEX = keys.TIME_REGEX;
export const OPERATING_AIRLINES_REGEX = keys.OPERATING_AIRLINES_REGEX;
export const TRAVEL_TYPES = keys.TRAVEL_TYPES;
export const CABINS = keys.CABINS;
export const FLIGHT_PATH_REGEX = keys.FLIGHT_PATH_REGEX;
export const SEGMENT_FLIGH_NUMBER_REGEX = keys.SEGMENT_FLIGH_NUMBER_REGEX;
export const SEGMENT_OPERATOR_REGEX = keys.SEGMENT_OPERATOR_REGEX;
export const BUSINESS_UNITS = keys.BUSINESS_UNITS;
export const LIMIT_PASSENGERS = keys.LIMIT_PASSENGERS;
export const CUSTOMER_FFP_CATEGORIES = keys.CUSTOMER_FFP_CATEGORIES;
export const PAYMENT_METHODS_REGEX = keys.PAYMENT_METHODS_REGEX;
export const ANTICIPATION_PURCHASE_DAYS = keys.ANTICIPATION_PURCHASE_DAYS;
export const GENDERS = keys.GENDERS;
export const PRODUCT_ID_NAME_REGEX = keys.PRODUCT_ID_NAME_REGEX;
export const MILES_MONEY_REGEX = keys.MILES_MONEY_REGEX;
export const PRODUCT_BRAND = keys.PRODUCT_BRAND;
export const PRODUCT_CATEGORY_LEVEL_ONE = keys.PRODUCT_CATEGORY_LEVEL_ONE;
export const PRODUCT_CATEGORY_LEVEL_TWO = keys.PRODUCT_CATEGORY_LEVEL_TWO;
export const PRODUCT_CATEGORY_LEVEL_THREE_REGEX =
  keys.PRODUCT_CATEGORY_LEVEL_THREE_REGEX;
export const PRODUCT_CATEGORY_LEVEL_FOUR_DEFAULT =
  keys.PRODUCT_CATEGORY_LEVEL_FOUR_DEFAULT;
export const PRODUCT_CATEGORY_LEVEL_FOUR_REGEX =
  keys.PRODUCT_CATEGORY_LEVEL_FOUR_REGEX;
export const PRODUCT_CATEGORY_LEVEL_FIVE_REGEX =
  keys.PRODUCT_CATEGORY_LEVEL_FIVE_REGEX;
export const PRODUCT_VARIANT_REGEX = keys.PRODUCT_VARIANT_REGEX;
export const PNR_REGEX = keys.PNR_REGEX;
export const PRODUCT_MIN_NUMBER = keys.PRODUCT_MIN_NUMBER;
export const MAX_SCORE = keys.MAX_SCORE;
export const PROMO_ID_NAME_REGEX = keys.PROMO_ID_NAME_REGEX;
export const PROMO_POSITION_REGEX = keys.PROMO_POSITION_REGEX;
export const PURCHASE_MIN_MONEY = keys.PURCHASE_MIN_MONEY;
export const CUSTOMER_SCOPE = keys.CUSTOMER_SCOPE;
export const PROFILE_TYPE = keys.PROFILE_TYPE;
export const PASSENGER_TYPE = keys.PASSENGER_TYPE;
export const SESSION_CONTROL = keys.SESSION_CONTROL;
export const FLIGHT_TYPE = keys.FLIGHT_TYPE;
export const SEARCH_TYPE = keys.SEARCH_TYPE;
export const MOBILE_ACCESS_COOKIE = keys.MOBILE_ACCESS_COOKIE;
export const MULTIPLE_STRING_REGEX = keys.MULTIPLE_STRING_REGEX;
export const DIGITAL_SERVICES = keys.DIGITAL_SERVICES;
export const CLICK_TYPES = keys.CLICK_TYPES;
export const FEEDBACK_VALUES = keys.FEEDBACK_VALUES;
export const FLIGHT_NUMBER_REGEX = keys.FLIGHT_NUMBER_REGEX;